import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Table
} from "reactstrap";
import NoRecord from "../../../components/common/NoRecord";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import TimezoneClock from "../../../components/common/TimeZone";
import PaginationBlock2 from "../../../components/common/PaginationBlock2";
import moment from "moment";
toast.configure();

/**
 * @description component use for update/add location
 */
const AuditLogModal = ({
  title,
  showModel,
  _toggle,
  page,
  limit,
  _handleLimit,
  _handlePageChange,
}) => {
  const userDetail = useSelector((state) => state?.user?.user);
  const documentLogs = useSelector((state) => state?.document?.documentLogs)
  console.log(documentLogs," documentLogs")
  return (
    <>
      <Modal isOpen={showModel} toggle={() => _toggle()} backdrop="static">
        <ModalHeader>
          {title}
          <Button color="link" onClick={() => _toggle()}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="34"
              height="34"
              viewBox="0 0 34 34"
            >
              <g data-name="Group 651" transform="translate(-1535 -134)">
                <g
                  fill="#fff"
                  stroke="#000"
                  strokeWidth="2"
                  data-name="Ellipse 30"
                  opacity="0.3"
                  transform="translate(1535 134)"
                >
                  <circle cx="17" cy="17" r="17" stroke="none"></circle>
                  <circle cx="17" cy="17" r="16" fill="none"></circle>
                </g>
                <path
                  d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
                  data-name="Icon ionic-ios-close"
                  opacity="0.3"
                  transform="translate(1534.289 132.789)"
                ></path>
              </g>
            </svg>
          </Button>
        </ModalHeader>
        <ModalBody>

        {documentLogs &&  documentLogs?.docs && documentLogs?.docs?.length !== 0
            ? <Table responsive>

            <thead>
              <tr>
                <th className='sort-heading'>
                  <div className="sort-elem-cell d-inline-flex align-items-center">
                  UserName
                  </div>
                </th>
                <th>Role</th>
                <th>Email</th>
                <th>Log</th>
                <th>Date Modified</th>
              </tr>
            </thead>
            <tbody>
              {
                documentLogs?.docs.map((item, index) => {
                  return (
                    <tr>
                      {item?.user ? <td>{item?.user?.fname} {item?.user?.lname}</td> : item?.admin ?  <td>{item?.admin?.fname} {item?.admin?.lname}</td> : <td>-</td>}
                      {item?.user ? <td>{item?.userRole?.roleName}</td> : item?.admin ? <td>{item?.adminRole?.roleName}</td> : <td>Mori Support</td>}
                      {item?.user ? <td>{item?.user?.email}</td> : item?.admin ? <td>{item?.admin?.email}</td> : <td>-</td>}
                      <td>{item?.logDetail}</td>
                      <td>
                          {(item?.updatedAt && userDetail?.timezone) ? <><TimezoneClock timezone={userDetail.timezone} dateTime={item?.updatedAt} timeFormat={"MMM DD,YYYY"} /> at <TimezoneClock timezone={userDetail.timezone} dateTime={item?.updatedAt} timeFormat={"h:mm a"} /></> : moment(item?.updatedAt).format(
                              "MMM DD,YYYY"
                          ) + ' at ' + moment(item?.updatedAt).format(
                              "h:mm a"
                          )}
                      </td>     
                    </tr>
                  )
                })
              }
            </tbody>
          </Table>
            : documentLogs && documentLogs?.docs && documentLogs?.docs.length === 0 && <NoRecord />}
          { documentLogs && documentLogs?.docs && documentLogs?.docs.length && documentLogs?.docs.length !== 0 ? <PaginationBlock2 page={page} limit={limit} organizations={documentLogs} __handleLimit={_handleLimit} __handlePageChange={_handlePageChange} hide={"hide"} /> : null}

        </ModalBody>
       
      </Modal>
    </>
  );
};

export default AuditLogModal;
